export const insertHtmlAtSelection = (
  editorEl: HTMLDivElement,
  html: string,
  onFallback: () => void,
  onChange: () => void,
) => {
  const selection = window.getSelection();
  editorEl.focus();

  const isSelectionInside =
    selection &&
    selection.rangeCount > 0 &&
    editorEl.contains(selection.getRangeAt(0).commonAncestorContainer);

  if (!selection || !isSelectionInside) {
    onFallback();
    return;
  }

  const range = selection.getRangeAt(0);
  range.deleteContents();
  const fragment = range.createContextualFragment(html);
  const lastNode = fragment.lastChild;
  range.insertNode(fragment);

  if (lastNode) {
    range.setStartAfter(lastNode);
    range.collapse(true);
    selection.removeAllRanges();
    selection.addRange(range);
  }

  onChange();
};
